import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-chevron-left\"><path d=\"M8.646 11.354 5.293 8.001l3.353-3.354.708.707-2.647 2.647 2.647 2.646z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol